(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-section-nav"] && !Shopify.designMode) return;
  try {
    class ScrollSectionNav extends HTMLElement {
    connectedCallback() {
      const main = document.getElementById('MainContent');

      if (!main || main.dataset.template !== 'index') {
        this.remove();
        return;
      }

      this.sections = Array.from(main.querySelectorAll(':scope > .shopify-section')).filter(
        (section) => section.offsetHeight > 0
      );

      if (this.sections.length < 2) {
        this.remove();
        return;
      }

      this.buttons = this.sections.map((section, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'scroll-section-nav__segment';
        button.setAttribute('aria-label', `Zu Abschnitt ${index + 1} springen`);
        button.addEventListener('click', () => {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        this.appendChild(button);
        return button;
      });

      this.removeAttribute('aria-hidden');
      this.classList.add('is-visible');

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = this.sections.indexOf(entry.target);
            this.#setActive(index);
          });
        },
        { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
      );

      this.sections.forEach((section) => this.observer.observe(section));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    #setActive(activeIndex) {
      this.buttons.forEach((button, index) => {
        button.classList.toggle('is-active', index === activeIndex);
      });
    }
  }

  if (!customElements.get('scroll-section-nav')) {
    customElements.define('scroll-section-nav', ScrollSectionNav);
  }
  } catch(e) { console.error(e); }
})();

})();
